// extracted by mini-css-extract-plugin
export default {"root":"styles_root__jcxx5","errorPage":"styles_errorPage__A2kXc","textContent":"styles_textContent__3-1Lk","title":"styles_title__CH0hZ","description":"styles_description__PSr6Q"};